import React, { CSSProperties, FC, ReactNode, useState } from 'react'
import { useBreakpoint } from '@mtsbank/ui-kit'
import { Icon, ToolTipMobileText, ToolTipText } from '@shared/ui/atoms'
import { useTheme } from '@shared/lib'
import { ToolTipProps } from '../atoms/ToolTipText'

interface DesktopMobileTooltipProps extends ToolTipProps {
  modalTitle: string
  hint: ReactNode
  mobileIconStyles?: CSSProperties
}

const DesktopMobileTooltip: FC<DesktopMobileTooltipProps> = ({ modalTitle, hint, mobileIconStyles, ...props }) => {
  const [isModalActive, setIsModalActive] = useState(false)

  const { isMobile } = useBreakpoint()
  const theme = useTheme()

  const handleModalOpen = () => {
    setIsModalActive(true)
  }

  const handleModalClose = () => {
    setIsModalActive(false)
  }

  return isMobile ? (
    <>
      <Icon
        onClick={handleModalOpen}
        icon="baseX24/question-circle"
        color={theme.colors.icon.tertiary}
        style={mobileIconStyles}
      />
      <ToolTipMobileText open={isModalActive} title={modalTitle} handleClose={handleModalClose}>
        {hint}
      </ToolTipMobileText>
    </>
  ) : (
    <ToolTipText
      interactive
      zIndex={999}
      onHidden={() => {}}
      onClick={(e) => {
        e.stopPropagation()
      }}
      hint={hint}
      {...props}
    />
  )
}

export default DesktopMobileTooltip
